import React from "react";

import { CONTACT_DETAILS } from "../../utils/stateTypes";

const LINKS = [
  {
    url: CONTACT_DETAILS.INSTAGRAM,
    label: "Instagram",
    icon: "/images/social-1.png",
  },
  {
    url: CONTACT_DETAILS.FACEBOOK,
    label: "Facebook",
    icon: "/images/social-2.png",
  },
].filter((x) => x.url);

//Round green social icons (header & footer) - a network is left out if its link is blank
const SocialLinks = ({ className = "" }) => {
  if (!LINKS.length) {
    return null;
  }

  return (
    <div className={`social-links ${className}`}>
      {LINKS.map((link) => (
        <a
          key={link.label}
          href={link.url}
          target={"_blank"}
          rel={"noopener noreferrer"}
          aria-label={link.label}
        >
          <img
            src={link.icon}
            alt={""}
            width={35}
            height={35}
          />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
